/**
 * DSExplorer API
 * Read only APIs for interacting with the AAD Directory Store and helping discover data.
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* 0 = None 1 = AccountEnabled 2 = AccountId 3 = AssignedLicense 4 = AssignedPlan 6 = Assistant 7 = AuthorizedIdentity 8 = AuthorizedServiceInstance 10 = Builtin 11 = CountryLetterCode 12 = Capability 13 = CloudLegacyExchangeDN 14 = CloudMSExchArchiveStatus 15 = CloudMSExchBlockedSendersHash 16 = CloudMSExchMailboxGuid 17 = CloudMSExchSafeRecipientsHash 18 = CloudMSExchSafeSendersHash 19 = CloudMSExchUCVoiceMailSettings 20 = Country 21 = CompanyName 22 = CompanyLastDirSyncTime 23 = ContractId 24 = ContractType 25 = CountryLetterCodes 26 = CountryCode 27 = CustomView 28 = DeliverAndRedirect 29 = DefaultGeography 30 = Department 31 = Description 32 = DirSyncEnabled 33 = DisplayName 34 = EmployeeId 35 = ExtensionAttribute1 36 = ExtensionAttribute2 37 = ExtensionAttribute3 38 = ExtensionAttribute4 39 = ExtensionAttribute5 40 = ExtensionAttribute6 41 = ExtensionAttribute7 42 = ExtensionAttribute8 43 = ExtensionAttribute9 44 = ExtensionAttribute10 45 = ExtensionAttribute11 46 = ExtensionAttribute12 47 = ExtensionAttribute13 48 = ExtensionAttribute14 49 = ExtensionAttribute15 50 = FacsimileTelephoneNumber 51 = ForeignContextId 52 = ForeignPrincipalId 53 = GivenName 54 = HideDLMembership 55 = HomePhone 56 = Info 57 = Initials 58 = InternetEncoding 59 = IPPhone 60 = City 61 = LastDirSyncTime 62 = LiveAuthorizationScope 63 = LicenseType 64 = Mail 65 = MailEnabled 66 = MailNickname 67 = MaximumOverageUnits 68 = MaximumOverageUnitsDetail 69 = MiddleName 70 = MigrationDetail 71 = MigrationSourceAnchor 72 = MigrationState 73 = Mobile 74 = MSDSHABSeniorityIndex 75 = MSDSPhoneticDisplayName 76 = MSExchArchiveGuid 77 = MSExchArchiveName 78 = MSExchAssistantName 79 = MSExchEnableModeration 80 = MSExchGroupDepartRestriction 81 = MSExchGroupJoinRestriction 82 = MSExchHideFromAddressLists 83 = MSExchImmutableId 84 = MSExchMailboxGuid 85 = MSExchModerationFlags 86 = MSExchRecipientDisplayType 87 = MSExchRemoteRecipientType 88 = MSExchRequireAuthToSendTo 89 = MSExchResourceCapacity 90 = MSExchResourceDisplay 91 = MSExchResourceMetadata 92 = MSExchResourceSearchProperties 93 = MSExchSenderHintTranslations 94 = MSOrgIsOrganizational 95 = MSRtcSipDeploymentLocator 96 = MSRtcSipLine 97 = MSRtcSipPrimaryUserAddress 98 = MSRtcSipUserEnabled 99 = NextLifecycleDate 101 = OcpMessageId 102 = OcpOrganizationId 103 = OcpSubscriptionId 104 = OofReplyToOriginator 105 = OtherFacsimileTelephoneNumber 106 = OtherHomePhone 107 = OtherIPPhone 108 = OtherMail 109 = OtherMobile 110 = OtherPager 111 = OtherTelephone 112 = OwnerIdentifier 113 = Pager 114 = PartnerCommerceUrl 115 = PartnerCompanyName 116 = PartnerHelpUrl 117 = PartnerServiceType 118 = PartnerSupportEmail 119 = PartnerSupportTelephone 120 = PartnerSupportUrl 121 = PartNumber 122 = PasswordPolicies 123 = PhysicalDeliveryOfficeName 124 = PlanId 125 = PortalSetting 126 = PostalCode 127 = PostOfficeBox 128 = PreferredLanguage 129 = PrepaidUnits 130 = PrepaidUnitsDetail 131 = ProvisionedPlan 132 = ProvisionedServiceInstance 133 = ProxyAddresses 134 = QuotaAmount 135 = RegionName 136 = ReportToOriginator 137 = RoleDisabled 138 = RoleTemplateId 139 = ScopeId 140 = ScopeFilterOn 141 = ScopeFilterValue 142 = ScopeParameterType 143 = ScopeTargetTypes 144 = SecurityEnabled 145 = ServiceInfo 146 = ServiceInstanceName 147 = ServiceInstanceMap 148 = ServicePlanGranted 149 = ServiceType 150 = ShadowAlias 152 = ShadowCommonName 153 = ShadowLegacyExchangeDN 154 = ShadowMail 155 = ShadowProxyAddresses 156 = ShadowTargetAddress 157 = ShadowUserPrincipalName 158 = SkuId 159 = Surname 160 = SourceAnchor 161 = State 162 = StartDate 163 = Street 164 = StreetAddress 165 = SubscriptionStatus 166 = SubsetOf 167 = SupportRole 168 = TaskIdList 169 = TaskId 170 = TaskSetId 171 = TargetAddress 172 = TargetClass 173 = TaskSetScopeReference 174 = TargetContextId 175 = TaskName 177 = TelephoneAssistant 178 = TelephoneNumber 179 = TenantType 180 = ThumbnailPhoto 181 = JobTitle 182 = UnverifiedDomain 183 = Url 184 = UsageLocation 185 = UserPrincipalName 186 = ValidationError 187 = VerifiedDomain 188 = WellKnownObject 189 = WindowsLiveNetId 190 = WwwHomepage 191 = PropagationTask 192 = BelongsToFirstLoginObjectSet 193 = FirstLoginObjectCount 194 = ServiceOriginatedResource 195 = CloudMSExchRecipientDisplayType 196 = MSExchBlockedSendersHash 197 = MSExchSafeRecipientsHash 198 = MSExchSafeSendersHash 199 = SipProxyAddress 200 = PartnerSkuId 201 = ServiceInstanceInfo 202 = CloudSipProxyAddress 203 = TechnicalNotificationMail 204 = ServicePlanName 205 = CreationTime 206 = MSRtcSipOptionFlags 207 = MSExchElcMailboxFlags 208 = MSExchElcExpirySuspensionEnd 209 = MSExchElcExpirySuspensionStart 210 = MSExchRetentionComment 211 = MSExchRetentionUrl 212 = MSExchLitigationHoldDate 213 = MSExchLitigationHoldOwner 214 = MSExchMailboxAuditEnable 215 = MSExchMailboxAuditLogAgeLimit 216 = MSExchAuditAdmin 217 = MSExchAuditDelegate 218 = MSExchAuditDelegateAdmin 219 = MSExchAuditOwner 220 = MSExchBypassAudit 221 = MSExchRecipientTypeDetails 222 = ReportToOwner 223 = DependsOnServicePlan 224 = RestrictedUsageLocations 225 = ProhibitedUsageLocations 226 = PartnerBillingSupportEmail 227 = BillingNotificationEmails 228 = MarketingNotificationEmails 229 = ThrottlePolicyId 230 = ThrottleLimits 231 = ShadowDisplayName 232 = ReplicationScope 233 = GeographicLocation 234 = BesServiceInstance 235 = DirSyncStatus 236 = DirSyncStatusAck 237 = ShadowMobile 238 = DirSyncOverrides 239 = SelfServePasswordResetEnabled 240 = AuthorizedParty 241 = ServiceInstanceOptions 242 = DeferredSyncCompanyQuotaLimit 243 = ContextPriorityQuotaLimit 244 = OrgIdPropagationTask 245 = SiteName 246 = ServiceEndpoints 247 = SoftDeletionTimestamp 248 = ServiceInstanceConfig 249 = DatacenterRedirections 250 = TrialSubscription 251 = TotalTrialUnitsDetail 252 = MSExchTeamMailboxOwners 253 = MSExchTeamMailboxSharePointLinkedBy 254 = MSExchTeamMailboxSharePointUrl 255 = MSExchExtensionCustomAttribute1 256 = MSExchExtensionCustomAttribute2 257 = MSExchExtensionCustomAttribute3 258 = MSExchExtensionCustomAttribute4 259 = MSExchExtensionCustomAttribute5 260 = Credential 261 = ServicePrincipalName 262 = TrustedForDelegation 263 = CompanyPartnership 264 = AppPrincipalId 265 = ServicePrincipalTemplate 266 = ContextMoveWatermarks 267 = ComplianceRequirements 268 = ContextMoveFrom 269 = ContextMoveTo 270 = ContextMoveSyncCookie 271 = AppAddress 272 = LastRestorationTimestamp 273 = SliceId 274 = TenantRange 275 = SliceStatus 276 = RightsManagementTenantConfiguration 277 = RightsManagementTenantKey 278 = RightsManagementUserKey 279 = ServiceOptions 280 = ExternalUserAccountDelegationsAllowed 281 = DelegationEncodingVersion 282 = DelegationType 283 = UserIdentifierType 284 = UserIdentifier 285 = DelegationEndTime 286 = DelegationScope 287 = AuthorizedRestrictedSyncAttributeSet 288 = KeyGroupId 289 = KeyDescription 290 = EncryptedSecretKey 291 = AsymmetricKey 292 = SharedKeyReference 293 = BuildNumber 294 = SecretEncryptionCertificate 295 = CompanyTags 296 = AlternativeSecurityId 297 = MSExchUserHoldPolicies 298 = MSRtcSipOwnerUrn 299 = MSRtcSipApplicationOptions 300 = MSExchTeamMailboxExpiration 301 = OnPremiseSecurityIdentifier 302 = StrongAuthenticationPolicy 303 = StrongAuthenticationMethod 304 = FeatureDescriptorIds 305 = FeatureDescriptorId 306 = FeatureStatus 307 = SubjectName 308 = Thumbprint 309 = IssuerName 310 = ExpirationDate 311 = CertificateAuthority 312 = ServicePrincipalTag 313 = FeatureOptions 314 = CloudMSExchUserHoldPolicies 315 = ContextMoveOutWatermarks 316 = StsTokenType 317 = StsTokenLifetime 318 = StsBooleanPropertiesBitmap 319 = ShadowOtherMobile 320 = StrongAuthenticationRequirement 321 = CloudMSExchTeamMailboxOwners 322 = CloudMSExchTeamMailboxExpiration 323 = CloudMSExchTeamMailboxSharePointUrl 324 = RightsManagementLastKnownGoodTenantConfiguration 325 = StsAddress 326 = StsName 327 = MicrosoftPolicyGroup 328 = DirSyncFeatures 329 = PasswordSyncTime 330 = ServiceConfig 331 = IsDedicated 332 = DedicatedTenantId 333 = ServiceInstanceSelectionTagPrefix 334 = StrongAuthenticationDetails 335 = TypeName 336 = ConfigurationData 337 = AppId 338 = MainLogo 339 = AppIdentifierUri 340 = PublicClient 341 = AvailableToOtherTenants 342 = AppContextId 343 = MultiStepOperation 344 = PublisherName 345 = ApproximateLastLogonTimestamp 346 = CloudAccountEnabled 347 = CloudDisplayName 348 = DeviceId 349 = DeviceOSType 350 = CloudDeviceOSType 351 = DeviceOSVersion 352 = CloudDeviceOSVersion 353 = DeviceObjectVersion 354 = DevicePhysicalIds 355 = TenantIds 356 = EncryptedExternalSecret 357 = Entitlement 358 = EntitlementGrantEncodingVersion 359 = EntitlementId 360 = EntitlementGrantRevoked 361 = EntitlementGrantId 362 = TenantCustomizationData 363 = AppMetadata 364 = StrongAuthenticationPhoneAppDetail 365 = RoleName 366 = MainlineSlice 367 = SliceRecord 368 = AssignedRoleSlice 369 = TenantSliceStatus 370 = CreatedOnBehalfOf 371 = ProvisioningSince 372 = ChangeMarker 373 = AppOptions 374 = CloudCreated 375 = LastPasswordChangeTimestamp 376 = EncryptedPasswordHash 377 = EncryptedPasswordHashHistory 378 = StrongAuthenticationProofupTime 379 = CredentialBooleanPropertiesBitmap 380 = TakeoverAction 381 = LoginTenantBranding 382 = StsRefreshTokensValidFrom 383 = StsSamlResponseSigningPolicy 384 = HomeRealmDiscoveryDisplayName 385 = StsProtocolType 386 = StsProviderSpecificData 387 = StsRulesBlob 388 = StsClaimCountLimits 389 = IssuerUri 390 = DomainName 391 = UserType 392 = UserCertificate 393 = UserSMIMECertificate 394 = O365ShellUserThemeIdentifier 395 = O365ShellUserLandingPageIdentifier 396 = PublicIssuerCertificates 397 = CloudPublicIssuerCertificates 398 = RegistrationQuota 399 = MaximumRegistrationInactivityPeriod 400 = EntitlementGrantCreationTime 401 = TrustedRealmContextId 402 = AllowCollaborationSpaceAccessTo 403 = SubscriptionChangeNotificationId 404 = CommerceSubscriptionContext 405 = ServicePrincipalAuthenticationPolicy 407 = ResourceApplicationSet 408 = WebApp 409 = WebApi 410 = ExplicitAccessGrantRequired 411 = RequiredResourceAccess 412 = EncryptedAppPasswordHashes 413 = EncryptedAppPasswordHashHistory 414 = ShadowLastPasswordChangeTimestamp 415 = ExtensionAttributeDefinition 416 = StringExtensionAttribute 417 = BinaryExtensionAttribute 418 = GroupType 419 = ExchangeResources 420 = SharepointResources 421 = IsPublic 422 = DirectoryFeatures 423 = AppAuxiliaryId 424 = DirSyncConfiguration 425 = TenantSoftDeletionTimestamp 426 = ServiceDiscoveryEndpoint 427 = LocalizedAppBrandingElements 428 = AppBrandingElements 429 = DataReplicationScopeName 430 = SupportedDataReplicationScopes 431 = AllowActAsForAllClients 432 = LogoBackgroundColor 433 = AdminConsentSSO 434 = AddOnService 435 = OnPremisePasswordChangeTimestamp 436 = ForwardSyncAccessRule 437 = GroupMembershipClaims 438 = KnownClientApplications 439 = LicenseAssignmentDetail 440 = GroupLicenseEarliestSuspensionTimestamp 441 = GroupBasedLicenseErrorCode 442 = GroupLicenseAssignment 443 = GroupBasedLicenseErrorOccuredEncodingVersion 444 = ForwardSyncOptions 445 = IsCompliant 446 = IsManaged 447 = ExchangeActiveSyncId 448 = AllowGuestsSignIn 449 = UseEmailBasedDiscoveryUX 450 = PreferredTokenSigningKeyThumbprint 451 = UseCustomTokenSigningKey 452 = ResourceAppAccessPolicy 453 = ResourceAppAccessPolicyMetadata 454 = SelfServePasswordResetPolicy 455 = SelfServePasswordResetData 456 = UserState 457 = UserStateChangedOn 458 = AcceptedAs 459 = AcceptedOn 460 = CreatedOn 461 = InviteReplyUrl 462 = CreationType 463 = InviteResources 464 = InviteTicket 465 = DateTimeExtensionAttribute 466 = MSExchUserCreatedTimestamp 467 = LargeIntegerExtensionAttribute 468 = MSExchTransportRecipientSettingsFlags 469 = MSExchRecipientSoftDeletedStatus 470 = DefaultUsageLocation 471 = BooleanExtensionAttribute 472 = IntegerExtensionAttribute 473 = ForwardSyncScopeReplayTrigger 474 = AuthorizedTestServiceInstances 475 = StrongAuthenticationUserDetails 476 = ScopeEncodingVersion 477 = ScopeIdentifier 478 = SignInName 479 = LogonIdentifier 480 = ServicePlanProperties 481 = PolicyDetail 482 = PolicyType 483 = TenantDefaultPolicy 484 = SearchableDeviceKey 485 = IdPType 486 = DirSyncProvisioningError 487 = SiteId 488 = ManagedTenantDomainNames 489 = EncryptedCompromisedPasswordHashHistory 490 = IsCompromised 491 = OnPremisesUserPrincipalName 492 = PermissionId 493 = LocaleCode 494 = LocalizedPermissionStrings 495 = OauthOidcResponsePolicyBitmap 496 = OAuth2LegacyUrlPathMatching 497 = DeviceKey 498 = DeviceTrustType 499 = DeviceMetadata 500 = StrongAuthenticationEncryptedPinHash 501 = StrongAuthenticationEncryptedPinHashHistory 502 = FOPEConflictProxyAddress 503 = SecurityComplianceNotificationMail 504 = SecurityComplianceNotificationPhone 505 = RealmConfiguration 506 = IsInactivated 507 = CustomDeviceId 508 = SuspensionReason 509 = OwnerContextId 510 = OwnerPrincipalId 511 = SubscriptionSuspensionReason 512 = TransitionSource 513 = TransitionTarget 514 = TransitionType 515 = CommerceSubscriptionState 516 = SubscriptionFriendlyName 517 = HasOnPremisesShadow 518 = O365TenantReleaseTrack 519 = O365CompassEnabled 520 = O365UserReleaseTrack 521 = AppCategory 522 = AppData 523 = DnsDomainName 524 = NetBiosName 525 = EncryptedMsiApplicationSecret 526 = OnPremisesSamAccountName 527 = DefaultSearchScope 528 = AdministrativeUnitReference 529 = WindowsLegacyCredentials 530 = WindowsSupplementalCredentials 531 = MsaAppId 532 = GroupLicenseAssignmentTimestamp 533 = WindowsCredentialsEncryptionCertificate 534 = PreferredDataLocation 535 = MdmAppId 536 = AddIns 537 = IsSynchronizationServiceAccount 538 = PolicyIdentifier 539 = BitLockerKey 540 = AssignableScopes 541 = GrantedPermissions 542 = RoleAssignmentEncodingVersion 543 = RoleAssignmentScope 544 = RoleAssignmentScopeConstraints 545 = RoleAssignmentCondition 546 = DeviceSystemMetadata 547 = RecordConsentConditions 548 = CreatedByConsentConditions 549 = MembershipRule 550 = IsMembershipRuleLocked 551 = MembershipRuleProcessingState 552 = AppLogoUrl 553 = AppInformationalUrl 554 = ApplicationTag 555 = CloudAudioConferencingProviderInfo 556 = CloudSipLine 557 = CloudRtcUserPolicies 558 = GroupCreationOptions 559 = CompliantUntil 560 = UserPreference 561 = ObjectIdHistory 562 = ClaimValue 564 = AllowedDataLocation 565 = IsMnc 566 = BackSyncEnabled 568 = AppCreatedDateTime 569 = Classification 570 = IsMembershipHidden 571 = SupportedClaimTypes 572 = SigningCertificateUpdateStatus 573 = TrustedCAsForPasswordlessAuth 574 = RenewedDateTime 575 = CreatedDateTime 576 = ObjectSettings 577 = ObjectSettingTemplateId 578 = TemplateDetails 579 = Epoch 580 = PartitionId 581 = DeletionTimestamp 582 = Version 583 = InactivationTimestamp 584 = CloudIdentity 586 = IsHiddenMembershipEnabled 587 = CloudMSRtcIsSipEnabled 588 = CloudMSRtcOwnerUrn 589 = CloudMSRtcPolicyAssignments 590 = CloudMSRtcPool 591 = CloudMSRtcServiceAttributes 597 = WorkloadDataLocationName 598 = ServicePrincipalType 599 = AlternativeNames 600 = SecurityEnabledBeforeSoftDeletion 601 = PreviousTenantIds 604 = WorkloadDataLocationRegionName 605 = WorkloadDataLocationCountryLetterCode 607 = TakeoverConflicts 611 = MostRecentPreviousTenant 612 = SupportedDataLocation 615 = PreAuthorizedApplications 616 = OrganizationalUnit 617 = DeviceOwnership 618 = DeviceManufacturer 619 = DeviceModel 620 = ManagementType 621 = IsRooted 622 = EnrollmentProfileName 623 = EnrollmentType 624 = DeviceCategory 625 = IntuneGroupId 626 = IntuneDeviceId 629 = SkypespacesServiceAttributes 630 = LastStsRefreshTokenRevoked 631 = LastStsRefreshTokenInvalidatedByPasswordChange 633 = Theme 636 = SegregatedAppContextId 638 = ServicePrincipalLifecyclePolicy 639 = AccountEnabledByLifecyclePolicy 640 = RoleCustomId 642 = RoleVersion 645 = AccessTokenAcceptedVersion 646 = ResourceProvisioningOptions 647 = ResourceBehaviorOptions 649 = GroupLicenseProcessingDetail 650 = OptionalClaims 653 = UniqueDisplayName 654 = ExtensionAttributeStatus 655 = TargetObjectClasses 656 = OwnerApplicationId 658 = TokenEncryptionKeyId 666 = IncludesPermissionsFrom 667 = PublisherDomain 668 = RoleHidden 669 = WindowsInformationProtectionKey 670 = SocialIdpBindEncodingVersion 671 = SocialIdpBindUserIdentifier 672 = SocialIdpBindAccessToken 673 = SocialIdpBindAccessTokenExpiry 674 = SocialIdpBindRefreshToken 675 = SocialIdpBindRefreshTokenExpiry 676 = ServiceInstanceMoveTrackers 677 = SecuredEncryptedPasswordHash 678 = SecuredEncryptedPasswordHashHistory 682 = AcceptMappedClaims 685 = OnPremisesDistinguishedName 696 = RolloutPlanName 697 = RolloutStages 698 = Environment 699 = SecuredStrongAuthenticationEncryptedPinHash 700 = IsDisabled 701 = SecuredStrongAuthenticationEncryptedPinHashHistory 702 = ServiceOwnerSecurityGroup 703 = LegalAgeGroup 704 = DateOfBirth 705 = InvitedAs 706 = OathTokenMetadata 707 = SecuredEncryptedAppPasswordHashes 708 = IsDeviceOnlyAuthSupported 709 = AllowPassthroughUsers 710 = TrustedCertificateSubject 711 = LegalAgeGroupRule 712 = CountriesBlockedForMinors 713 = IsExternal 714 = SecuredPartitionId 715 = SecuredKeyId 716 = SecuredEncryptionAlgorithm 717 = SecuredKeyLifecycleState 718 = SecuredPublicKey 719 = SocialIdpBindScopes 720 = GroupAuthorizationPolicies 721 = SocialIdpSetting 723 = PrivacyProfile 726 = AgeGroup 727 = ConsentProvidedForMinor 729 = CompliantAppsManagementAppId 730 = CompliantApplication 731 = SignInAudience 732 = OrgRestrictions 733 = SystemLabel 734 = ProfileType 736 = IsOrgIdReconciliationPending 737 = OrgIdReconciliationTimestamp 738 = Capabilities 739 = LocalCredentials 740 = IsResourceAccount 741 = SignAuthnRequestsToFedIDP 742 = SecuredEncryptedExternalSecrets 743 = PrimaryVerifiedDomain 744 = DomainVerificationCode 745 = ManagedIdentityResourceId 747 = AppRolloutPlan 748 = AppSafeUpdates 749 = KeyGroupSafeUpdates 750 = DisableCustomRoles 751 = MembershipType 752 = SecuredAppId 753 = IsDefault 755 = OverflowIndex 756 = IdentityAuthFeaturesRolloutFlag 757 = GroupExpirationDate 758 = IncludesClaimsFrom 759 = OverflowRecordCount 760 = KerberosDomainDnsName 761 = KerberosDomainDescription 762 = EncryptedKerberosDomainKey 763 = TrustingTenantId 764 = TrustedTenantId 765 = TenantTrustState 766 = GroupMappingApprovalsState 767 = UserAttributeMappingApprovalsState 768 = TenantTrustType 769 = GroupMappings 770 = UserAttributeMappings 771 = TrustingTenantContactEmails 772 = TrustedTenantContactEmails 773 = SearchableDeviceKeyProperty 778 = LastDirSyncMatchTimestamp 779 = ApplicationTemplateId 780 = NotificationEmailAddresses 781 = PreferredTokenSigningKeyEndDateTime 782 = PreferredSingleSignOnMode 783 = SamlSingleSignOnSettings 784 = GroupMembershipType 785 = SourceContext 786 = ExternalGroupState 787 = AuthoritativeSlice 788 = RemovedAppAddress 789 = DelegatedPermissionClassifications 790 = LabelId 791 = ProtectGroupLabelAction 792 = SecuredKeyOwner 793 = SupportedMsodsPartitions 794 = PreAuthorizedApplicationAsLink 797 = EncryptedDpapiEncryptionKey 798 = SecuredEncryptedDpapiEncryptionKey 799 = ScopedMemberScopeType 800 = AcceptsOnlyForwardableIdTokens 801 = ForwardableOnBehalfOfOriginsAcceptedAudiences 802 = ForwardableOnBehalfOfOriginsAcceptedPrecedingApps 803 = LoginUrl 804 = PermissionGrantDetails 805 = IsAssignableToRole 806 = AppRollout 807 = AcceptsOnlyForwardableAccessTokens 808 = SecuredAccessPassData 809 = StockKeepingUnitProperties 810 = Etag 811 = PermissionGrantPolicyIdsAssignedToDefaultUserRole 814 = OriginalContextId 815 = OriginalGroupId 816 = VerifiedPublisherId 817 = VerifiedPublisherName 818 = VerifiedPublisherLastUpdate 819 = VerifiedPublisherIsRevoked 820 = GroupProxyMappings 821 = GuestUserRole 822 = EnabledPreviewFeatures 823 = IsAuthorizationServiceEnabled 824 = CreatedByAppId 825 = InfoCatalogs 827 = RemoteTenantId 828 = RemotePrincipalId 829 = SourcedFrom 830 = RemotePrincipalPurpose 831 = Notes 838 = BlockMsolPowerShell 839 = IsCompanyAssociationRoot 840 = OriginalUserId 841 = InvitedContextId 842 = InvitedByContextId 843 = InvitationStatus 844 = AcceptanceCompletedOn 846 = SharedEmailDomain 847 = OwnedSharedEmailDomainMap 848 = UniqueName 849 = DisabledByMicrosoftStatus 850 = AssociationRootContextId 851 = AssociationType 852 = AssociationMembers 853 = IsGroupAuthorizationPoliciesSet 854 = ProcessingSharedEmailDomain 858 = DeviceExternalSourceName 859 = DeviceSourceType 861 = OriginContextId 874 = OriginatingCloud 884 = EmployeeHireDate 885 = EmployeeType 886 = EmployeeOrgData 890 = ArmResourceId 891 = AllowedTenantIds 892 = IsAllowedForAllTenants 893 = PrivateLinkIds 895 = IsWritebackEnabled 896 = TargetWritebackType 897 = GroupTags 898 = HostNames 899 = WritebackEnabledChangeTimestamp 900 = TenantsNotSyncedToAssociationRoot 901 = AttributeSet 902 = AttributeIdentifier 903 = CustomSecurityAttributeName 904 = Status 905 = DataType 906 = IsCollection 907 = UsePredefinedValuesOnly 909 = TrustedCertificateAuthorities 910 = TlsClientAuthParameter 911 = CertificateBasedDeviceAuthConfigurationId 912 = CertificateBasedDeviceAuthConfigurationTenantId 913 = DeviceAuthority 914 = DeviceAuthorityAppIds 916 = CustomSecurityAttributes1 917 = CustomSecurityAttributes2 918 = CustomSecurityAttributes3 919 = CustomSecurityAttributes4 920 = CustomSecurityConditionalAccessAttributes 922 = IsSearchable 923 = AdvancedOptions 924 = AllowedValues 926 = ServiceTreeId 927 = PrivateLinkId 930 = AssociationOwners 931 = IsDiscoverable 932 = UpdateVersion 934 = IsMemberManagementRestricted 935 = IsManagementRestricted 936 = InviterTenantVerificationRecordValue 937 = SignInPhoneNumber 938 = InvitedTenantVerificationRecordValue 939 = LicenseMigrationInfo 940 = SignInMail 941 = DataVersion 943 = AppMigrationSourceTenantId 944 = AppMigrationDestinationTenantId 945 = AppMigrationState 946 = AppMigrationStateLastUpdate 947 = MigrateTrafficForApp 948 = ServicePrincipalCreationDetails 949 = PreAuthorizedApplicationsDeflate 951 = PartnerIdentifier 952 = PartnerPolicyType 953 = PartnerPolicyDetail 954 = AgreementId 955 = AgreementTypeId 956 = AgreementIsViewingBeforeAcceptanceRequired 957 = AgreementIsPerDeviceAcceptanceRequired 958 = AgreementAcceptanceExpirationStartDateTime 959 = AgreementAcceptanceExpirationFrequency 960 = AgreementAcceptanceDuration 961 = AgreementAcceptedCount 962 = AgreementDeclinedCount 963 = AgreementPolicyFiles 964 = AgreementAcceptanceAgreementPolicyFileId 965 = AgreementAcceptanceDeviceId 966 = AgreementAcceptanceExpirationDateTime 971 = DefaultUserRoleOverrides 980 = MaxAttributesPerSet 981 = AdmissionDeclineJustification 982 = AdmissionDateTime 983 = AdmissionExpirationDateTime 984 = AdmissionResponseDateTime 985 = AdmittedDomain 986 = MemberTenantRole 987 = VerificationDomainForMember 988 = AttributeSetName 989 = MemberDisplayDomain 990 = NativeFederationCapability 991 = VerificationDomainForAdmitter 992 = FederatedIdentityCredentials 993 = EntitlementGrantRevocationTime 994 = OriginalContextDisplayName 995 = OriginalContextPrimaryDomain 996 = OriginalGroupDisplayName 997 = RequestSignatureVerification 999 = CreatedBy 1000 = SupervisorId 1001 = OrganizationName 1004 = AllowUserConsentForRiskyApps 1005 = PrivateLinkIds64Bits 1006 = ResourceTenantsConsentedTo 1007 = PartnerPolicyDetailVersion 1010 = IsPublisherAttested 1011 = LastCertificationDateTime 1012 = CertificationExpirationDateTime 1013 = IsSharedByDefault 1014 = AlwaysShareTo 1015 = NeverShareTo 1016 = SharedAttributes 1021 = AdmitterDisplayName 1022 = IsPolicyLocked 1025 = EntitlementGrantLastModifiedTime 1026 = LinkCreatedDateTime 1027 = LinkLastModifiedDateTime 1032 = Entitlement00Deflate 1033 = Entitlement01Deflate 1034 = Entitlement02Deflate 1035 = Entitlement03Deflate 1036 = Entitlement04Deflate 1037 = Entitlement05Deflate 1038 = Entitlement06Deflate 1039 = Entitlement07Deflate 1040 = DelegationSecondaryEncodingVersion 1041 = ServicePrincipalLockConfiguration 1042 = ServiceManagementReference 1043 = BillingConfiguration 1044 = ConditionalAccessEnforcedActions 1045 = ExternalUserConvertedOn 1049 = CertificateUserIds 1050 = OriginalObjectInformation 1051 = SyncProvisioningInformation 1062 = RemoteDesktopSecurityConfiguration 1063 = TrustedCAs 1064 = DataBoundary 1065 = ResourceTenantIds1 1066 = ResourceTenantIds2 1067 = ResourceTenantIds3 1078 = EmployeeLeaveDate 1080 = TargetObjectClass 1081 = ObjectAuthority 1092 = PolicyDetailDescriptionMappings 1093 = UsageType 1094 = MultiTenantOrgPrimaryOwner 1095 = MultiTenantOrgActiveTenantsBlob 1096 = MultiTenantOrgActiveOwnersBlob 1097 = MultiTenantOrgTenantId 1098 = MultiTenantOrgAddedByTenantId 1099 = MultiTenantOrgTenantRole 1100 = MultiTenantOrgTenantState 1101 = MultiTenantOrgTenantAddedDateTime 1102 = MultiTenantOrgTenantJoinedDateTime 1104 = PermissionGrantPolicyIdsAssignedToGuestUserRole 1105 = AuthenticationBehaviors 1106 = IssuerHashValue 1107 = IssuerUrlPattern 1108 = ComparisonOperator 1109 = TrustedIssuerTagName 1110 = OriginalObjectId 1111 = MultiTenantOrgId 1112 = MultiTenantOrgType 1113 = MultiTenantOrgPendingPrimaryOwner 1114 = IsMultiTenantOrgLocked 1115 = TokenEncryptionAudience 1116 = TokenEncryptionScheme 1117 = CertificateUserIdsExtensionAttribute1 1118 = CertificateUserIdsExtensionAttribute2 1119 = CertificateUserIdsExtensionAttribute3 1120 = CertificateUserIdsExtensionAttribute4 1121 = CertificateUserIdsExtensionAttribute5 1122 = CertificateUserIdsExtensionHashes 1123 = SamlSLOBindingType 1124 = OnPremisesObjectIdentifier 1125 = PartnerPolicyFeatureType 1126 = TokenEncryptionAvailableVersions 1127 = TokenEncryptionCurrentVersion 1128 = ArmUniqueName 1129 = ClientId 1130 = PublicKeyInfrastructureState 1131 = PublicKeyInfrastructureUsageType 1132 = PublicKeyInfrastructureLastModifiedBy 1133 = TrustedCertificateExt01 1134 = TrustedCertificateExt02 1135 = TrustedCertificateExt03 1136 = CertificateRevocationListUrl 1137 = DeltaCertificateRevocationListUrl 1138 = CertificateAuthorityType 1139 = AuthorizedKeyIdentifier 1140 = IssuerSki 1141 = CertificateAuthorityExpiryTime 1142 = SubjectNameRawData 1143 = IssuerSkiHash 1144 = IssuerHintEnabled 1145 = CertificateAuthorityUsageType 1147 = DeveloperId 1148 = KeyId 1149 = InsiderRiskLevel 1151 = PreviousCellIds 1152 = LicenseAssignmentMetadata 1154 = VerifiedDomainName 1178 = TokensRevocationDateTime 1179 = AzureDnsPartition 1180 = RiskLevelThreatLevel 1181 = RiskLevelThreatLastComputedDateTime 1182 = PublicKeyInfrastructureIdHash 1183 = OrganizationalUnitLineage 1184 = MovingFromOrganizationalUnitLineage 1185 = MultiTenantOrgLabelType 1186 = MultiTenantOrgLabelValue 1187 = PublicKeyInfrastructureLastModifiedDateTime 1188 = PublicKeyInfrastructureLastDisplayNameHash 1189 = NativeAuthenticationApisEnabled 1190 = QRCodeCredentials 1191 = QRPinCredential 1192 = QRPinHistory 1193 = ManagerApplications 1194 = PartnerPolicyDetailExt01 1195 = ThemeName 1196 = Locale 1197 = CompanyBrandingIdAndLocale 1198 = LayoutTemplateType 1199 = HeaderBackgroundColor 1200 = PageBackgroundColor 1201 = TermsOfUse 1202 = PrivacyAndCookies 1203 = ForgotMyPassword 1204 = AccountResetCredentials 1205 = ResetItNow 1206 = CannotAccessYourAccount 1207 = PageHeader 1208 = PageFooter 1209 = UsernameHintText 1210 = ImageAssets1 1211 = ImageAssets2 1212 = ClientAssets 1213 = ContentCustomization1 1214 = ContentCustomization2 1217 = CertificateAuthorityEntityThumbprint 1218 = CertificateAuthorityEntityThumbprintHash 1219 = CertificateAuthenticationMethods 1220 = CertificateUserIdsExtensionAttribute6 1221 = CertificateUserIdsExtensionAttribute7 1222 = CertificateUserIdsExtensionAttribute8 1223 = CertificateUserIdsExtensionAttribute9 1224 = CertificateUserIdsExtensionAttribute10 1225 = CertificateUserIdsExtensionAttribute11 1226 = CertificateUserIdsExtensionAttribute12 1227 = CertificateUserIdsExtensionAttribute13 1228 = CertificateUserIdsExtensionAttribute14 1229 = CertificateUserIdsExtensionAttribute15 1230 = CertificateUserIdsExtensionAttribute16 1231 = CertificateUserIdsExtensionAttribute17 1232 = CertificateUserIdsExtensionAttribute18 1233 = CertificateUserIdsExtensionAttribute19 1234 = CertificateUserIdsExtensionAttribute20 1235 = EamCredentials 1236 = CustomIconUrl 1237 = ProtocolVersion 1238 = ProtocolData 1239 = InboundClaimMapping 1244 = CompanyBrandingThemeNameHash 1245 = CompanyBrandingLocaleHash 1246 = SignInPageBinary 1247 = StrategicCustomerTypes 1248 = DecentralizedIdentifiers 1251 = TargetScope 1256 = ResourceTenantIdsChangedOn 1257 = SubscriptionStatusDate 1263 = HomeTenantId 1264 = AddTenantIds 1265 = RemoveTenantIds 1266 = StatusCode 1267 = UpdatedOn 1268 = FederatedIdentityCredentialsData 1270 = AssignmentRequiredPrincipalTypes 1271 = CrossDomainDataSCIMv2ExternalId 1272 = HomeTenantPartitionId 1273 = TokenRevocations 1274 = FederatedIdentityCredentialsVersion 1275 = TenantStage 1276 = DisabledDateTime 1277 = SignInAudienceRestrictions 1278 = SignInAudienceRestrictionsMode 1281 = CommerceBillingContext 1282 = AppRolloutHeader 1283 = AppRollout2 1284 = ProviderType 1285 = ProviderMetadata 1286 = ProviderCredentials 1287 = ProviderDisplayName 1289 = InstanceOf 1290 = ServicePrincipalSubtypes 1291 = AppTypes 1292 = ServicePrincipalCreatedByAppId 1293 = AgentAppId
*/
export enum MicrosoftOnlineDirectoryServicesDirectoryProperty {
    None = 0,
    AccountEnabled = 1,
    AccountId = 2,
    AssignedLicense = 3,
    AssignedPlan = 4,
    Assistant = 6,
    AuthorizedIdentity = 7,
    AuthorizedServiceInstance = 8,
    Builtin = 10,
    CountryLetterCode = 11,
    Capability = 12,
    CloudLegacyExchangeDN = 13,
    CloudMSExchArchiveStatus = 14,
    CloudMSExchBlockedSendersHash = 15,
    CloudMSExchMailboxGuid = 16,
    CloudMSExchSafeRecipientsHash = 17,
    CloudMSExchSafeSendersHash = 18,
    CloudMSExchUCVoiceMailSettings = 19,
    Country = 20,
    CompanyName = 21,
    CompanyLastDirSyncTime = 22,
    ContractId = 23,
    ContractType = 24,
    CountryLetterCodes = 25,
    CountryCode = 26,
    CustomView = 27,
    DeliverAndRedirect = 28,
    DefaultGeography = 29,
    Department = 30,
    Description = 31,
    DirSyncEnabled = 32,
    DisplayName = 33,
    EmployeeId = 34,
    ExtensionAttribute1 = 35,
    ExtensionAttribute2 = 36,
    ExtensionAttribute3 = 37,
    ExtensionAttribute4 = 38,
    ExtensionAttribute5 = 39,
    ExtensionAttribute6 = 40,
    ExtensionAttribute7 = 41,
    ExtensionAttribute8 = 42,
    ExtensionAttribute9 = 43,
    ExtensionAttribute10 = 44,
    ExtensionAttribute11 = 45,
    ExtensionAttribute12 = 46,
    ExtensionAttribute13 = 47,
    ExtensionAttribute14 = 48,
    ExtensionAttribute15 = 49,
    FacsimileTelephoneNumber = 50,
    ForeignContextId = 51,
    ForeignPrincipalId = 52,
    GivenName = 53,
    HideDLMembership = 54,
    HomePhone = 55,
    Info = 56,
    Initials = 57,
    InternetEncoding = 58,
    IPPhone = 59,
    City = 60,
    LastDirSyncTime = 61,
    LiveAuthorizationScope = 62,
    LicenseType = 63,
    Mail = 64,
    MailEnabled = 65,
    MailNickname = 66,
    MaximumOverageUnits = 67,
    MaximumOverageUnitsDetail = 68,
    MiddleName = 69,
    MigrationDetail = 70,
    MigrationSourceAnchor = 71,
    MigrationState = 72,
    Mobile = 73,
    MSDSHABSeniorityIndex = 74,
    MSDSPhoneticDisplayName = 75,
    MSExchArchiveGuid = 76,
    MSExchArchiveName = 77,
    MSExchAssistantName = 78,
    MSExchEnableModeration = 79,
    MSExchGroupDepartRestriction = 80,
    MSExchGroupJoinRestriction = 81,
    MSExchHideFromAddressLists = 82,
    MSExchImmutableId = 83,
    MSExchMailboxGuid = 84,
    MSExchModerationFlags = 85,
    MSExchRecipientDisplayType = 86,
    MSExchRemoteRecipientType = 87,
    MSExchRequireAuthToSendTo = 88,
    MSExchResourceCapacity = 89,
    MSExchResourceDisplay = 90,
    MSExchResourceMetadata = 91,
    MSExchResourceSearchProperties = 92,
    MSExchSenderHintTranslations = 93,
    MSOrgIsOrganizational = 94,
    MSRtcSipDeploymentLocator = 95,
    MSRtcSipLine = 96,
    MSRtcSipPrimaryUserAddress = 97,
    MSRtcSipUserEnabled = 98,
    NextLifecycleDate = 99,
    OcpMessageId = 101,
    OcpOrganizationId = 102,
    OcpSubscriptionId = 103,
    OofReplyToOriginator = 104,
    OtherFacsimileTelephoneNumber = 105,
    OtherHomePhone = 106,
    OtherIPPhone = 107,
    OtherMail = 108,
    OtherMobile = 109,
    OtherPager = 110,
    OtherTelephone = 111,
    OwnerIdentifier = 112,
    Pager = 113,
    PartnerCommerceUrl = 114,
    PartnerCompanyName = 115,
    PartnerHelpUrl = 116,
    PartnerServiceType = 117,
    PartnerSupportEmail = 118,
    PartnerSupportTelephone = 119,
    PartnerSupportUrl = 120,
    PartNumber = 121,
    PasswordPolicies = 122,
    PhysicalDeliveryOfficeName = 123,
    PlanId = 124,
    PortalSetting = 125,
    PostalCode = 126,
    PostOfficeBox = 127,
    PreferredLanguage = 128,
    PrepaidUnits = 129,
    PrepaidUnitsDetail = 130,
    ProvisionedPlan = 131,
    ProvisionedServiceInstance = 132,
    ProxyAddresses = 133,
    QuotaAmount = 134,
    RegionName = 135,
    ReportToOriginator = 136,
    RoleDisabled = 137,
    RoleTemplateId = 138,
    ScopeId = 139,
    ScopeFilterOn = 140,
    ScopeFilterValue = 141,
    ScopeParameterType = 142,
    ScopeTargetTypes = 143,
    SecurityEnabled = 144,
    ServiceInfo = 145,
    ServiceInstanceName = 146,
    ServiceInstanceMap = 147,
    ServicePlanGranted = 148,
    ServiceType = 149,
    ShadowAlias = 150,
    ShadowCommonName = 152,
    ShadowLegacyExchangeDN = 153,
    ShadowMail = 154,
    ShadowProxyAddresses = 155,
    ShadowTargetAddress = 156,
    ShadowUserPrincipalName = 157,
    SkuId = 158,
    Surname = 159,
    SourceAnchor = 160,
    State = 161,
    StartDate = 162,
    Street = 163,
    StreetAddress = 164,
    SubscriptionStatus = 165,
    SubsetOf = 166,
    SupportRole = 167,
    TaskIdList = 168,
    TaskId = 169,
    TaskSetId = 170,
    TargetAddress = 171,
    TargetClass = 172,
    TaskSetScopeReference = 173,
    TargetContextId = 174,
    TaskName = 175,
    TelephoneAssistant = 177,
    TelephoneNumber = 178,
    TenantType = 179,
    ThumbnailPhoto = 180,
    JobTitle = 181,
    UnverifiedDomain = 182,
    Url = 183,
    UsageLocation = 184,
    UserPrincipalName = 185,
    ValidationError = 186,
    VerifiedDomain = 187,
    WellKnownObject = 188,
    WindowsLiveNetId = 189,
    WwwHomepage = 190,
    PropagationTask = 191,
    BelongsToFirstLoginObjectSet = 192,
    FirstLoginObjectCount = 193,
    ServiceOriginatedResource = 194,
    CloudMSExchRecipientDisplayType = 195,
    MSExchBlockedSendersHash = 196,
    MSExchSafeRecipientsHash = 197,
    MSExchSafeSendersHash = 198,
    SipProxyAddress = 199,
    PartnerSkuId = 200,
    ServiceInstanceInfo = 201,
    CloudSipProxyAddress = 202,
    TechnicalNotificationMail = 203,
    ServicePlanName = 204,
    CreationTime = 205,
    MSRtcSipOptionFlags = 206,
    MSExchElcMailboxFlags = 207,
    MSExchElcExpirySuspensionEnd = 208,
    MSExchElcExpirySuspensionStart = 209,
    MSExchRetentionComment = 210,
    MSExchRetentionUrl = 211,
    MSExchLitigationHoldDate = 212,
    MSExchLitigationHoldOwner = 213,
    MSExchMailboxAuditEnable = 214,
    MSExchMailboxAuditLogAgeLimit = 215,
    MSExchAuditAdmin = 216,
    MSExchAuditDelegate = 217,
    MSExchAuditDelegateAdmin = 218,
    MSExchAuditOwner = 219,
    MSExchBypassAudit = 220,
    MSExchRecipientTypeDetails = 221,
    ReportToOwner = 222,
    DependsOnServicePlan = 223,
    RestrictedUsageLocations = 224,
    ProhibitedUsageLocations = 225,
    PartnerBillingSupportEmail = 226,
    BillingNotificationEmails = 227,
    MarketingNotificationEmails = 228,
    ThrottlePolicyId = 229,
    ThrottleLimits = 230,
    ShadowDisplayName = 231,
    ReplicationScope = 232,
    GeographicLocation = 233,
    BesServiceInstance = 234,
    DirSyncStatus = 235,
    DirSyncStatusAck = 236,
    ShadowMobile = 237,
    DirSyncOverrides = 238,
    SelfServePasswordResetEnabled = 239,
    AuthorizedParty = 240,
    ServiceInstanceOptions = 241,
    DeferredSyncCompanyQuotaLimit = 242,
    ContextPriorityQuotaLimit = 243,
    OrgIdPropagationTask = 244,
    SiteName = 245,
    ServiceEndpoints = 246,
    SoftDeletionTimestamp = 247,
    ServiceInstanceConfig = 248,
    DatacenterRedirections = 249,
    TrialSubscription = 250,
    TotalTrialUnitsDetail = 251,
    MSExchTeamMailboxOwners = 252,
    MSExchTeamMailboxSharePointLinkedBy = 253,
    MSExchTeamMailboxSharePointUrl = 254,
    MSExchExtensionCustomAttribute1 = 255,
    MSExchExtensionCustomAttribute2 = 256,
    MSExchExtensionCustomAttribute3 = 257,
    MSExchExtensionCustomAttribute4 = 258,
    MSExchExtensionCustomAttribute5 = 259,
    Credential = 260,
    ServicePrincipalName = 261,
    TrustedForDelegation = 262,
    CompanyPartnership = 263,
    AppPrincipalId = 264,
    ServicePrincipalTemplate = 265,
    ContextMoveWatermarks = 266,
    ComplianceRequirements = 267,
    ContextMoveFrom = 268,
    ContextMoveTo = 269,
    ContextMoveSyncCookie = 270,
    AppAddress = 271,
    LastRestorationTimestamp = 272,
    SliceId = 273,
    TenantRange = 274,
    SliceStatus = 275,
    RightsManagementTenantConfiguration = 276,
    RightsManagementTenantKey = 277,
    RightsManagementUserKey = 278,
    ServiceOptions = 279,
    ExternalUserAccountDelegationsAllowed = 280,
    DelegationEncodingVersion = 281,
    DelegationType = 282,
    UserIdentifierType = 283,
    UserIdentifier = 284,
    DelegationEndTime = 285,
    DelegationScope = 286,
    AuthorizedRestrictedSyncAttributeSet = 287,
    KeyGroupId = 288,
    KeyDescription = 289,
    EncryptedSecretKey = 290,
    AsymmetricKey = 291,
    SharedKeyReference = 292,
    BuildNumber = 293,
    SecretEncryptionCertificate = 294,
    CompanyTags = 295,
    AlternativeSecurityId = 296,
    MSExchUserHoldPolicies = 297,
    MSRtcSipOwnerUrn = 298,
    MSRtcSipApplicationOptions = 299,
    MSExchTeamMailboxExpiration = 300,
    OnPremiseSecurityIdentifier = 301,
    StrongAuthenticationPolicy = 302,
    StrongAuthenticationMethod = 303,
    FeatureDescriptorIds = 304,
    FeatureDescriptorId = 305,
    FeatureStatus = 306,
    SubjectName = 307,
    Thumbprint = 308,
    IssuerName = 309,
    ExpirationDate = 310,
    CertificateAuthority = 311,
    ServicePrincipalTag = 312,
    FeatureOptions = 313,
    CloudMSExchUserHoldPolicies = 314,
    ContextMoveOutWatermarks = 315,
    StsTokenType = 316,
    StsTokenLifetime = 317,
    StsBooleanPropertiesBitmap = 318,
    ShadowOtherMobile = 319,
    StrongAuthenticationRequirement = 320,
    CloudMSExchTeamMailboxOwners = 321,
    CloudMSExchTeamMailboxExpiration = 322,
    CloudMSExchTeamMailboxSharePointUrl = 323,
    RightsManagementLastKnownGoodTenantConfiguration = 324,
    StsAddress = 325,
    StsName = 326,
    MicrosoftPolicyGroup = 327,
    DirSyncFeatures = 328,
    PasswordSyncTime = 329,
    ServiceConfig = 330,
    IsDedicated = 331,
    DedicatedTenantId = 332,
    ServiceInstanceSelectionTagPrefix = 333,
    StrongAuthenticationDetails = 334,
    TypeName = 335,
    ConfigurationData = 336,
    AppId = 337,
    MainLogo = 338,
    AppIdentifierUri = 339,
    PublicClient = 340,
    AvailableToOtherTenants = 341,
    AppContextId = 342,
    MultiStepOperation = 343,
    PublisherName = 344,
    ApproximateLastLogonTimestamp = 345,
    CloudAccountEnabled = 346,
    CloudDisplayName = 347,
    DeviceId = 348,
    DeviceOSType = 349,
    CloudDeviceOSType = 350,
    DeviceOSVersion = 351,
    CloudDeviceOSVersion = 352,
    DeviceObjectVersion = 353,
    DevicePhysicalIds = 354,
    TenantIds = 355,
    EncryptedExternalSecret = 356,
    Entitlement = 357,
    EntitlementGrantEncodingVersion = 358,
    EntitlementId = 359,
    EntitlementGrantRevoked = 360,
    EntitlementGrantId = 361,
    TenantCustomizationData = 362,
    AppMetadata = 363,
    StrongAuthenticationPhoneAppDetail = 364,
    RoleName = 365,
    MainlineSlice = 366,
    SliceRecord = 367,
    AssignedRoleSlice = 368,
    TenantSliceStatus = 369,
    CreatedOnBehalfOf = 370,
    ProvisioningSince = 371,
    ChangeMarker = 372,
    AppOptions = 373,
    CloudCreated = 374,
    LastPasswordChangeTimestamp = 375,
    EncryptedPasswordHash = 376,
    EncryptedPasswordHashHistory = 377,
    StrongAuthenticationProofupTime = 378,
    CredentialBooleanPropertiesBitmap = 379,
    TakeoverAction = 380,
    LoginTenantBranding = 381,
    StsRefreshTokensValidFrom = 382,
    StsSamlResponseSigningPolicy = 383,
    HomeRealmDiscoveryDisplayName = 384,
    StsProtocolType = 385,
    StsProviderSpecificData = 386,
    StsRulesBlob = 387,
    StsClaimCountLimits = 388,
    IssuerUri = 389,
    DomainName = 390,
    UserType = 391,
    UserCertificate = 392,
    UserSMIMECertificate = 393,
    O365ShellUserThemeIdentifier = 394,
    O365ShellUserLandingPageIdentifier = 395,
    PublicIssuerCertificates = 396,
    CloudPublicIssuerCertificates = 397,
    RegistrationQuota = 398,
    MaximumRegistrationInactivityPeriod = 399,
    EntitlementGrantCreationTime = 400,
    TrustedRealmContextId = 401,
    AllowCollaborationSpaceAccessTo = 402,
    SubscriptionChangeNotificationId = 403,
    CommerceSubscriptionContext = 404,
    ServicePrincipalAuthenticationPolicy = 405,
    ResourceApplicationSet = 407,
    WebApp = 408,
    WebApi = 409,
    ExplicitAccessGrantRequired = 410,
    RequiredResourceAccess = 411,
    EncryptedAppPasswordHashes = 412,
    EncryptedAppPasswordHashHistory = 413,
    ShadowLastPasswordChangeTimestamp = 414,
    ExtensionAttributeDefinition = 415,
    StringExtensionAttribute = 416,
    BinaryExtensionAttribute = 417,
    GroupType = 418,
    ExchangeResources = 419,
    SharepointResources = 420,
    IsPublic = 421,
    DirectoryFeatures = 422,
    AppAuxiliaryId = 423,
    DirSyncConfiguration = 424,
    TenantSoftDeletionTimestamp = 425,
    ServiceDiscoveryEndpoint = 426,
    LocalizedAppBrandingElements = 427,
    AppBrandingElements = 428,
    DataReplicationScopeName = 429,
    SupportedDataReplicationScopes = 430,
    AllowActAsForAllClients = 431,
    LogoBackgroundColor = 432,
    AdminConsentSSO = 433,
    AddOnService = 434,
    OnPremisePasswordChangeTimestamp = 435,
    ForwardSyncAccessRule = 436,
    GroupMembershipClaims = 437,
    KnownClientApplications = 438,
    LicenseAssignmentDetail = 439,
    GroupLicenseEarliestSuspensionTimestamp = 440,
    GroupBasedLicenseErrorCode = 441,
    GroupLicenseAssignment = 442,
    GroupBasedLicenseErrorOccuredEncodingVersion = 443,
    ForwardSyncOptions = 444,
    IsCompliant = 445,
    IsManaged = 446,
    ExchangeActiveSyncId = 447,
    AllowGuestsSignIn = 448,
    UseEmailBasedDiscoveryUX = 449,
    PreferredTokenSigningKeyThumbprint = 450,
    UseCustomTokenSigningKey = 451,
    ResourceAppAccessPolicy = 452,
    ResourceAppAccessPolicyMetadata = 453,
    SelfServePasswordResetPolicy = 454,
    SelfServePasswordResetData = 455,
    UserState = 456,
    UserStateChangedOn = 457,
    AcceptedAs = 458,
    AcceptedOn = 459,
    CreatedOn = 460,
    InviteReplyUrl = 461,
    CreationType = 462,
    InviteResources = 463,
    InviteTicket = 464,
    DateTimeExtensionAttribute = 465,
    MSExchUserCreatedTimestamp = 466,
    LargeIntegerExtensionAttribute = 467,
    MSExchTransportRecipientSettingsFlags = 468,
    MSExchRecipientSoftDeletedStatus = 469,
    DefaultUsageLocation = 470,
    BooleanExtensionAttribute = 471,
    IntegerExtensionAttribute = 472,
    ForwardSyncScopeReplayTrigger = 473,
    AuthorizedTestServiceInstances = 474,
    StrongAuthenticationUserDetails = 475,
    ScopeEncodingVersion = 476,
    ScopeIdentifier = 477,
    SignInName = 478,
    LogonIdentifier = 479,
    ServicePlanProperties = 480,
    PolicyDetail = 481,
    PolicyType = 482,
    TenantDefaultPolicy = 483,
    SearchableDeviceKey = 484,
    IdPType = 485,
    DirSyncProvisioningError = 486,
    SiteId = 487,
    ManagedTenantDomainNames = 488,
    EncryptedCompromisedPasswordHashHistory = 489,
    IsCompromised = 490,
    OnPremisesUserPrincipalName = 491,
    PermissionId = 492,
    LocaleCode = 493,
    LocalizedPermissionStrings = 494,
    OauthOidcResponsePolicyBitmap = 495,
    OAuth2LegacyUrlPathMatching = 496,
    DeviceKey = 497,
    DeviceTrustType = 498,
    DeviceMetadata = 499,
    StrongAuthenticationEncryptedPinHash = 500,
    StrongAuthenticationEncryptedPinHashHistory = 501,
    FOPEConflictProxyAddress = 502,
    SecurityComplianceNotificationMail = 503,
    SecurityComplianceNotificationPhone = 504,
    RealmConfiguration = 505,
    IsInactivated = 506,
    CustomDeviceId = 507,
    SuspensionReason = 508,
    OwnerContextId = 509,
    OwnerPrincipalId = 510,
    SubscriptionSuspensionReason = 511,
    TransitionSource = 512,
    TransitionTarget = 513,
    TransitionType = 514,
    CommerceSubscriptionState = 515,
    SubscriptionFriendlyName = 516,
    HasOnPremisesShadow = 517,
    O365TenantReleaseTrack = 518,
    O365CompassEnabled = 519,
    O365UserReleaseTrack = 520,
    AppCategory = 521,
    AppData = 522,
    DnsDomainName = 523,
    NetBiosName = 524,
    EncryptedMsiApplicationSecret = 525,
    OnPremisesSamAccountName = 526,
    DefaultSearchScope = 527,
    AdministrativeUnitReference = 528,
    WindowsLegacyCredentials = 529,
    WindowsSupplementalCredentials = 530,
    MsaAppId = 531,
    GroupLicenseAssignmentTimestamp = 532,
    WindowsCredentialsEncryptionCertificate = 533,
    PreferredDataLocation = 534,
    MdmAppId = 535,
    AddIns = 536,
    IsSynchronizationServiceAccount = 537,
    PolicyIdentifier = 538,
    BitLockerKey = 539,
    AssignableScopes = 540,
    GrantedPermissions = 541,
    RoleAssignmentEncodingVersion = 542,
    RoleAssignmentScope = 543,
    RoleAssignmentScopeConstraints = 544,
    RoleAssignmentCondition = 545,
    DeviceSystemMetadata = 546,
    RecordConsentConditions = 547,
    CreatedByConsentConditions = 548,
    MembershipRule = 549,
    IsMembershipRuleLocked = 550,
    MembershipRuleProcessingState = 551,
    AppLogoUrl = 552,
    AppInformationalUrl = 553,
    ApplicationTag = 554,
    CloudAudioConferencingProviderInfo = 555,
    CloudSipLine = 556,
    CloudRtcUserPolicies = 557,
    GroupCreationOptions = 558,
    CompliantUntil = 559,
    UserPreference = 560,
    ObjectIdHistory = 561,
    ClaimValue = 562,
    AllowedDataLocation = 564,
    IsMnc = 565,
    BackSyncEnabled = 566,
    AppCreatedDateTime = 568,
    Classification = 569,
    IsMembershipHidden = 570,
    SupportedClaimTypes = 571,
    SigningCertificateUpdateStatus = 572,
    TrustedCAsForPasswordlessAuth = 573,
    RenewedDateTime = 574,
    CreatedDateTime = 575,
    ObjectSettings = 576,
    ObjectSettingTemplateId = 577,
    TemplateDetails = 578,
    Epoch = 579,
    PartitionId = 580,
    DeletionTimestamp = 581,
    Version = 582,
    InactivationTimestamp = 583,
    CloudIdentity = 584,
    IsHiddenMembershipEnabled = 586,
    CloudMSRtcIsSipEnabled = 587,
    CloudMSRtcOwnerUrn = 588,
    CloudMSRtcPolicyAssignments = 589,
    CloudMSRtcPool = 590,
    CloudMSRtcServiceAttributes = 591,
    WorkloadDataLocationName = 597,
    ServicePrincipalType = 598,
    AlternativeNames = 599,
    SecurityEnabledBeforeSoftDeletion = 600,
    PreviousTenantIds = 601,
    WorkloadDataLocationRegionName = 604,
    WorkloadDataLocationCountryLetterCode = 605,
    TakeoverConflicts = 607,
    MostRecentPreviousTenant = 611,
    SupportedDataLocation = 612,
    PreAuthorizedApplications = 615,
    OrganizationalUnit = 616,
    DeviceOwnership = 617,
    DeviceManufacturer = 618,
    DeviceModel = 619,
    ManagementType = 620,
    IsRooted = 621,
    EnrollmentProfileName = 622,
    EnrollmentType = 623,
    DeviceCategory = 624,
    IntuneGroupId = 625,
    IntuneDeviceId = 626,
    SkypespacesServiceAttributes = 629,
    LastStsRefreshTokenRevoked = 630,
    LastStsRefreshTokenInvalidatedByPasswordChange = 631,
    Theme = 633,
    SegregatedAppContextId = 636,
    ServicePrincipalLifecyclePolicy = 638,
    AccountEnabledByLifecyclePolicy = 639,
    RoleCustomId = 640,
    RoleVersion = 642,
    AccessTokenAcceptedVersion = 645,
    ResourceProvisioningOptions = 646,
    ResourceBehaviorOptions = 647,
    GroupLicenseProcessingDetail = 649,
    OptionalClaims = 650,
    UniqueDisplayName = 653,
    ExtensionAttributeStatus = 654,
    TargetObjectClasses = 655,
    OwnerApplicationId = 656,
    TokenEncryptionKeyId = 658,
    IncludesPermissionsFrom = 666,
    PublisherDomain = 667,
    RoleHidden = 668,
    WindowsInformationProtectionKey = 669,
    SocialIdpBindEncodingVersion = 670,
    SocialIdpBindUserIdentifier = 671,
    SocialIdpBindAccessToken = 672,
    SocialIdpBindAccessTokenExpiry = 673,
    SocialIdpBindRefreshToken = 674,
    SocialIdpBindRefreshTokenExpiry = 675,
    ServiceInstanceMoveTrackers = 676,
    SecuredEncryptedPasswordHash = 677,
    SecuredEncryptedPasswordHashHistory = 678,
    AcceptMappedClaims = 682,
    OnPremisesDistinguishedName = 685,
    RolloutPlanName = 696,
    RolloutStages = 697,
    Environment = 698,
    SecuredStrongAuthenticationEncryptedPinHash = 699,
    IsDisabled = 700,
    SecuredStrongAuthenticationEncryptedPinHashHistory = 701,
    ServiceOwnerSecurityGroup = 702,
    LegalAgeGroup = 703,
    DateOfBirth = 704,
    InvitedAs = 705,
    OathTokenMetadata = 706,
    SecuredEncryptedAppPasswordHashes = 707,
    IsDeviceOnlyAuthSupported = 708,
    AllowPassthroughUsers = 709,
    TrustedCertificateSubject = 710,
    LegalAgeGroupRule = 711,
    CountriesBlockedForMinors = 712,
    IsExternal = 713,
    SecuredPartitionId = 714,
    SecuredKeyId = 715,
    SecuredEncryptionAlgorithm = 716,
    SecuredKeyLifecycleState = 717,
    SecuredPublicKey = 718,
    SocialIdpBindScopes = 719,
    GroupAuthorizationPolicies = 720,
    SocialIdpSetting = 721,
    PrivacyProfile = 723,
    AgeGroup = 726,
    ConsentProvidedForMinor = 727,
    CompliantAppsManagementAppId = 729,
    CompliantApplication = 730,
    SignInAudience = 731,
    OrgRestrictions = 732,
    SystemLabel = 733,
    ProfileType = 734,
    IsOrgIdReconciliationPending = 736,
    OrgIdReconciliationTimestamp = 737,
    Capabilities = 738,
    LocalCredentials = 739,
    IsResourceAccount = 740,
    SignAuthnRequestsToFedIDP = 741,
    SecuredEncryptedExternalSecrets = 742,
    PrimaryVerifiedDomain = 743,
    DomainVerificationCode = 744,
    ManagedIdentityResourceId = 745,
    AppRolloutPlan = 747,
    AppSafeUpdates = 748,
    KeyGroupSafeUpdates = 749,
    DisableCustomRoles = 750,
    MembershipType = 751,
    SecuredAppId = 752,
    IsDefault = 753,
    OverflowIndex = 755,
    IdentityAuthFeaturesRolloutFlag = 756,
    GroupExpirationDate = 757,
    IncludesClaimsFrom = 758,
    OverflowRecordCount = 759,
    KerberosDomainDnsName = 760,
    KerberosDomainDescription = 761,
    EncryptedKerberosDomainKey = 762,
    TrustingTenantId = 763,
    TrustedTenantId = 764,
    TenantTrustState = 765,
    GroupMappingApprovalsState = 766,
    UserAttributeMappingApprovalsState = 767,
    TenantTrustType = 768,
    GroupMappings = 769,
    UserAttributeMappings = 770,
    TrustingTenantContactEmails = 771,
    TrustedTenantContactEmails = 772,
    SearchableDeviceKeyProperty = 773,
    LastDirSyncMatchTimestamp = 778,
    ApplicationTemplateId = 779,
    NotificationEmailAddresses = 780,
    PreferredTokenSigningKeyEndDateTime = 781,
    PreferredSingleSignOnMode = 782,
    SamlSingleSignOnSettings = 783,
    GroupMembershipType = 784,
    SourceContext = 785,
    ExternalGroupState = 786,
    AuthoritativeSlice = 787,
    RemovedAppAddress = 788,
    DelegatedPermissionClassifications = 789,
    LabelId = 790,
    ProtectGroupLabelAction = 791,
    SecuredKeyOwner = 792,
    SupportedMsodsPartitions = 793,
    PreAuthorizedApplicationAsLink = 794,
    EncryptedDpapiEncryptionKey = 797,
    SecuredEncryptedDpapiEncryptionKey = 798,
    ScopedMemberScopeType = 799,
    AcceptsOnlyForwardableIdTokens = 800,
    ForwardableOnBehalfOfOriginsAcceptedAudiences = 801,
    ForwardableOnBehalfOfOriginsAcceptedPrecedingApps = 802,
    LoginUrl = 803,
    PermissionGrantDetails = 804,
    IsAssignableToRole = 805,
    AppRollout = 806,
    AcceptsOnlyForwardableAccessTokens = 807,
    SecuredAccessPassData = 808,
    StockKeepingUnitProperties = 809,
    Etag = 810,
    PermissionGrantPolicyIdsAssignedToDefaultUserRole = 811,
    OriginalContextId = 814,
    OriginalGroupId = 815,
    VerifiedPublisherId = 816,
    VerifiedPublisherName = 817,
    VerifiedPublisherLastUpdate = 818,
    VerifiedPublisherIsRevoked = 819,
    GroupProxyMappings = 820,
    GuestUserRole = 821,
    EnabledPreviewFeatures = 822,
    IsAuthorizationServiceEnabled = 823,
    CreatedByAppId = 824,
    InfoCatalogs = 825,
    RemoteTenantId = 827,
    RemotePrincipalId = 828,
    SourcedFrom = 829,
    RemotePrincipalPurpose = 830,
    Notes = 831,
    BlockMsolPowerShell = 838,
    IsCompanyAssociationRoot = 839,
    OriginalUserId = 840,
    InvitedContextId = 841,
    InvitedByContextId = 842,
    InvitationStatus = 843,
    AcceptanceCompletedOn = 844,
    SharedEmailDomain = 846,
    OwnedSharedEmailDomainMap = 847,
    UniqueName = 848,
    DisabledByMicrosoftStatus = 849,
    AssociationRootContextId = 850,
    AssociationType = 851,
    AssociationMembers = 852,
    IsGroupAuthorizationPoliciesSet = 853,
    ProcessingSharedEmailDomain = 854,
    DeviceExternalSourceName = 858,
    DeviceSourceType = 859,
    OriginContextId = 861,
    OriginatingCloud = 874,
    EmployeeHireDate = 884,
    EmployeeType = 885,
    EmployeeOrgData = 886,
    ArmResourceId = 890,
    AllowedTenantIds = 891,
    IsAllowedForAllTenants = 892,
    PrivateLinkIds = 893,
    IsWritebackEnabled = 895,
    TargetWritebackType = 896,
    GroupTags = 897,
    HostNames = 898,
    WritebackEnabledChangeTimestamp = 899,
    TenantsNotSyncedToAssociationRoot = 900,
    AttributeSet = 901,
    AttributeIdentifier = 902,
    CustomSecurityAttributeName = 903,
    Status = 904,
    DataType = 905,
    IsCollection = 906,
    UsePredefinedValuesOnly = 907,
    TrustedCertificateAuthorities = 909,
    TlsClientAuthParameter = 910,
    CertificateBasedDeviceAuthConfigurationId = 911,
    CertificateBasedDeviceAuthConfigurationTenantId = 912,
    DeviceAuthority = 913,
    DeviceAuthorityAppIds = 914,
    CustomSecurityAttributes1 = 916,
    CustomSecurityAttributes2 = 917,
    CustomSecurityAttributes3 = 918,
    CustomSecurityAttributes4 = 919,
    CustomSecurityConditionalAccessAttributes = 920,
    IsSearchable = 922,
    AdvancedOptions = 923,
    AllowedValues = 924,
    ServiceTreeId = 926,
    PrivateLinkId = 927,
    AssociationOwners = 930,
    IsDiscoverable = 931,
    UpdateVersion = 932,
    IsMemberManagementRestricted = 934,
    IsManagementRestricted = 935,
    InviterTenantVerificationRecordValue = 936,
    SignInPhoneNumber = 937,
    InvitedTenantVerificationRecordValue = 938,
    LicenseMigrationInfo = 939,
    SignInMail = 940,
    DataVersion = 941,
    AppMigrationSourceTenantId = 943,
    AppMigrationDestinationTenantId = 944,
    AppMigrationState = 945,
    AppMigrationStateLastUpdate = 946,
    MigrateTrafficForApp = 947,
    ServicePrincipalCreationDetails = 948,
    PreAuthorizedApplicationsDeflate = 949,
    PartnerIdentifier = 951,
    PartnerPolicyType = 952,
    PartnerPolicyDetail = 953,
    AgreementId = 954,
    AgreementTypeId = 955,
    AgreementIsViewingBeforeAcceptanceRequired = 956,
    AgreementIsPerDeviceAcceptanceRequired = 957,
    AgreementAcceptanceExpirationStartDateTime = 958,
    AgreementAcceptanceExpirationFrequency = 959,
    AgreementAcceptanceDuration = 960,
    AgreementAcceptedCount = 961,
    AgreementDeclinedCount = 962,
    AgreementPolicyFiles = 963,
    AgreementAcceptanceAgreementPolicyFileId = 964,
    AgreementAcceptanceDeviceId = 965,
    AgreementAcceptanceExpirationDateTime = 966,
    DefaultUserRoleOverrides = 971,
    MaxAttributesPerSet = 980,
    AdmissionDeclineJustification = 981,
    AdmissionDateTime = 982,
    AdmissionExpirationDateTime = 983,
    AdmissionResponseDateTime = 984,
    AdmittedDomain = 985,
    MemberTenantRole = 986,
    VerificationDomainForMember = 987,
    AttributeSetName = 988,
    MemberDisplayDomain = 989,
    NativeFederationCapability = 990,
    VerificationDomainForAdmitter = 991,
    FederatedIdentityCredentials = 992,
    EntitlementGrantRevocationTime = 993,
    OriginalContextDisplayName = 994,
    OriginalContextPrimaryDomain = 995,
    OriginalGroupDisplayName = 996,
    RequestSignatureVerification = 997,
    CreatedBy = 999,
    SupervisorId = 1000,
    OrganizationName = 1001,
    AllowUserConsentForRiskyApps = 1004,
    PrivateLinkIds64Bits = 1005,
    ResourceTenantsConsentedTo = 1006,
    PartnerPolicyDetailVersion = 1007,
    IsPublisherAttested = 1010,
    LastCertificationDateTime = 1011,
    CertificationExpirationDateTime = 1012,
    IsSharedByDefault = 1013,
    AlwaysShareTo = 1014,
    NeverShareTo = 1015,
    SharedAttributes = 1016,
    AdmitterDisplayName = 1021,
    IsPolicyLocked = 1022,
    EntitlementGrantLastModifiedTime = 1025,
    LinkCreatedDateTime = 1026,
    LinkLastModifiedDateTime = 1027,
    Entitlement00Deflate = 1032,
    Entitlement01Deflate = 1033,
    Entitlement02Deflate = 1034,
    Entitlement03Deflate = 1035,
    Entitlement04Deflate = 1036,
    Entitlement05Deflate = 1037,
    Entitlement06Deflate = 1038,
    Entitlement07Deflate = 1039,
    DelegationSecondaryEncodingVersion = 1040,
    ServicePrincipalLockConfiguration = 1041,
    ServiceManagementReference = 1042,
    BillingConfiguration = 1043,
    ConditionalAccessEnforcedActions = 1044,
    ExternalUserConvertedOn = 1045,
    CertificateUserIds = 1049,
    OriginalObjectInformation = 1050,
    SyncProvisioningInformation = 1051,
    RemoteDesktopSecurityConfiguration = 1062,
    TrustedCAs = 1063,
    DataBoundary = 1064,
    ResourceTenantIds1 = 1065,
    ResourceTenantIds2 = 1066,
    ResourceTenantIds3 = 1067,
    EmployeeLeaveDate = 1078,
    TargetObjectClass = 1080,
    ObjectAuthority = 1081,
    PolicyDetailDescriptionMappings = 1092,
    UsageType = 1093,
    MultiTenantOrgPrimaryOwner = 1094,
    MultiTenantOrgActiveTenantsBlob = 1095,
    MultiTenantOrgActiveOwnersBlob = 1096,
    MultiTenantOrgTenantId = 1097,
    MultiTenantOrgAddedByTenantId = 1098,
    MultiTenantOrgTenantRole = 1099,
    MultiTenantOrgTenantState = 1100,
    MultiTenantOrgTenantAddedDateTime = 1101,
    MultiTenantOrgTenantJoinedDateTime = 1102,
    PermissionGrantPolicyIdsAssignedToGuestUserRole = 1104,
    AuthenticationBehaviors = 1105,
    IssuerHashValue = 1106,
    IssuerUrlPattern = 1107,
    ComparisonOperator = 1108,
    TrustedIssuerTagName = 1109,
    OriginalObjectId = 1110,
    MultiTenantOrgId = 1111,
    MultiTenantOrgType = 1112,
    MultiTenantOrgPendingPrimaryOwner = 1113,
    IsMultiTenantOrgLocked = 1114,
    TokenEncryptionAudience = 1115,
    TokenEncryptionScheme = 1116,
    CertificateUserIdsExtensionAttribute1 = 1117,
    CertificateUserIdsExtensionAttribute2 = 1118,
    CertificateUserIdsExtensionAttribute3 = 1119,
    CertificateUserIdsExtensionAttribute4 = 1120,
    CertificateUserIdsExtensionAttribute5 = 1121,
    CertificateUserIdsExtensionHashes = 1122,
    SamlSLOBindingType = 1123,
    OnPremisesObjectIdentifier = 1124,
    PartnerPolicyFeatureType = 1125,
    TokenEncryptionAvailableVersions = 1126,
    TokenEncryptionCurrentVersion = 1127,
    ArmUniqueName = 1128,
    ClientId = 1129,
    PublicKeyInfrastructureState = 1130,
    PublicKeyInfrastructureUsageType = 1131,
    PublicKeyInfrastructureLastModifiedBy = 1132,
    TrustedCertificateExt01 = 1133,
    TrustedCertificateExt02 = 1134,
    TrustedCertificateExt03 = 1135,
    CertificateRevocationListUrl = 1136,
    DeltaCertificateRevocationListUrl = 1137,
    CertificateAuthorityType = 1138,
    AuthorizedKeyIdentifier = 1139,
    IssuerSki = 1140,
    CertificateAuthorityExpiryTime = 1141,
    SubjectNameRawData = 1142,
    IssuerSkiHash = 1143,
    IssuerHintEnabled = 1144,
    CertificateAuthorityUsageType = 1145,
    DeveloperId = 1147,
    KeyId = 1148,
    InsiderRiskLevel = 1149,
    PreviousCellIds = 1151,
    LicenseAssignmentMetadata = 1152,
    VerifiedDomainName = 1154,
    TokensRevocationDateTime = 1178,
    AzureDnsPartition = 1179,
    RiskLevelThreatLevel = 1180,
    RiskLevelThreatLastComputedDateTime = 1181,
    PublicKeyInfrastructureIdHash = 1182,
    OrganizationalUnitLineage = 1183,
    MovingFromOrganizationalUnitLineage = 1184,
    MultiTenantOrgLabelType = 1185,
    MultiTenantOrgLabelValue = 1186,
    PublicKeyInfrastructureLastModifiedDateTime = 1187,
    PublicKeyInfrastructureLastDisplayNameHash = 1188,
    NativeAuthenticationApisEnabled = 1189,
    QRCodeCredentials = 1190,
    QRPinCredential = 1191,
    QRPinHistory = 1192,
    ManagerApplications = 1193,
    PartnerPolicyDetailExt01 = 1194,
    ThemeName = 1195,
    Locale = 1196,
    CompanyBrandingIdAndLocale = 1197,
    LayoutTemplateType = 1198,
    HeaderBackgroundColor = 1199,
    PageBackgroundColor = 1200,
    TermsOfUse = 1201,
    PrivacyAndCookies = 1202,
    ForgotMyPassword = 1203,
    AccountResetCredentials = 1204,
    ResetItNow = 1205,
    CannotAccessYourAccount = 1206,
    PageHeader = 1207,
    PageFooter = 1208,
    UsernameHintText = 1209,
    ImageAssets1 = 1210,
    ImageAssets2 = 1211,
    ClientAssets = 1212,
    ContentCustomization1 = 1213,
    ContentCustomization2 = 1214,
    CertificateAuthorityEntityThumbprint = 1217,
    CertificateAuthorityEntityThumbprintHash = 1218,
    CertificateAuthenticationMethods = 1219,
    CertificateUserIdsExtensionAttribute6 = 1220,
    CertificateUserIdsExtensionAttribute7 = 1221,
    CertificateUserIdsExtensionAttribute8 = 1222,
    CertificateUserIdsExtensionAttribute9 = 1223,
    CertificateUserIdsExtensionAttribute10 = 1224,
    CertificateUserIdsExtensionAttribute11 = 1225,
    CertificateUserIdsExtensionAttribute12 = 1226,
    CertificateUserIdsExtensionAttribute13 = 1227,
    CertificateUserIdsExtensionAttribute14 = 1228,
    CertificateUserIdsExtensionAttribute15 = 1229,
    CertificateUserIdsExtensionAttribute16 = 1230,
    CertificateUserIdsExtensionAttribute17 = 1231,
    CertificateUserIdsExtensionAttribute18 = 1232,
    CertificateUserIdsExtensionAttribute19 = 1233,
    CertificateUserIdsExtensionAttribute20 = 1234,
    EamCredentials = 1235,
    CustomIconUrl = 1236,
    ProtocolVersion = 1237,
    ProtocolData = 1238,
    InboundClaimMapping = 1239,
    CompanyBrandingThemeNameHash = 1244,
    CompanyBrandingLocaleHash = 1245,
    SignInPageBinary = 1246,
    StrategicCustomerTypes = 1247,
    DecentralizedIdentifiers = 1248,
    TargetScope = 1251,
    ResourceTenantIdsChangedOn = 1256,
    SubscriptionStatusDate = 1257,
    HomeTenantId = 1263,
    AddTenantIds = 1264,
    RemoveTenantIds = 1265,
    StatusCode = 1266,
    UpdatedOn = 1267,
    FederatedIdentityCredentialsData = 1268,
    AssignmentRequiredPrincipalTypes = 1270,
    CrossDomainDataSCIMv2ExternalId = 1271,
    HomeTenantPartitionId = 1272,
    TokenRevocations = 1273,
    FederatedIdentityCredentialsVersion = 1274,
    TenantStage = 1275,
    DisabledDateTime = 1276,
    SignInAudienceRestrictions = 1277,
    SignInAudienceRestrictionsMode = 1278,
    CommerceBillingContext = 1281,
    AppRolloutHeader = 1282,
    AppRollout2 = 1283,
    ProviderType = 1284,
    ProviderMetadata = 1285,
    ProviderCredentials = 1286,
    ProviderDisplayName = 1287,
    InstanceOf = 1289,
    ServicePrincipalSubtypes = 1290,
    AppTypes = 1291,
    ServicePrincipalCreatedByAppId = 1292,
    AgentAppId = 1293
}
